<template>
  <c-layout :spinning="page.loading">
    <a-button @click="showAddCard">添加数据</a-button>
    <a-divider/>
    <a-card hoverable class="cards" v-for="item in dataList">
      <template v-if="item.type ===1">
        <img slot="cover" :src="item.image"/>
      </template>

      <template v-if="item.type ===0">
        <template>
          <span>标题：</span>
          <a-tooltip>
            <template slot="title"> {{ item.title }}</template>
            {{ item.title }}
          </a-tooltip>
          <a-divider/>
        </template>
        <template>
          <span>内容：</span>
          <a-tooltip>
            <template slot="title"> {{ item.content }}</template>
            {{ item.content }}
          </a-tooltip>
          <a-divider/>
        </template>
      </template>
      <template>
        <span>链接：</span>
        <a-tooltip>
          <template slot="title"> {{ item.url }}</template>
          <a :href="item.url">{{ item.url }}</a>
        </a-tooltip>
      </template>
      <template slot="actions" class="ant-card-actions">
        <a-button type="primary" size="small" @click="editCard(item)">编辑</a-button>
        <c-pop-button title="确定要删除吗？" type="danger" @click="delCard(item.id)" text="删除"/>
      </template>

    </a-card>
    <a-modal :visible="show.addCard" width="30%" @cancel="closeAddCard" @ok="submitAddCard" okText="确定" cancelText="关闭">
      <a-form-model :model="form.addCard" :label-col="labelCol" :wrapper-col="wrapperCol">
        <a-form-model-item label="类型">
          <a-radio-group v-model="form.addCard.type">
            <a-radio :value="item.value" v-for="item in options.types">
              <span>{{ item.label }}</span>
            </a-radio>
          </a-radio-group>
        </a-form-model-item>
        <template v-if="form.addCard.type === 0">
          <a-form-model-item label="标题">
            <a-input v-model="form.addCard.title"></a-input>
          </a-form-model-item>
          <a-form-model-item label="内容">
            <a-input v-model="form.addCard.content"></a-input>
          </a-form-model-item>
        </template>
        <template v-else>
          <a-form-model-item label="图片">
            <div class="clearfix">
              <a-upload :action="uploadConf.url" list-type="picture-card" :file-list="fileList" 
              			:headers="uploadConf.headers" :before-upload="beforeUpload" 
              			@change="uploadFile" @preview="handlePreview">
                <div v-if="fileList.length < 1">
                  <a-icon type="plus"/>
                  <div class="ant-upload-text">
                    上传图片
                  </div>
                </div>
              </a-upload>
              <a-modal :visible="show.previewVisible" :footer="null" @cancel="handleCancel">
                <img alt="example" style="width: 100%" :src="previewImage"/>
              </a-modal>
            </div>
          </a-form-model-item>
        </template>

        <a-form-model-item label="链接">
          <a-input v-model="form.addCard.url"></a-input>
        </a-form-model-item>
        <a-form-model-item label="顺序">
          <a-input-number v-model="form.addCard.sort"></a-input-number>
        </a-form-model-item>
      </a-form-model>
    </a-modal>

  </c-layout>
</template>

<script>
import {CustomApis as api} from "@/api/CustomApis";
import {SysApis} from "@/api/SysApis";
import CPopButton from "../../components/c-pop-button";

export default {
  components: {CPopButton},
  data() {
    return {
      labelCol: {span: 5},
      wrapperCol: {span: 16},
      dataList: [],
      page: {
        loading: false,
      },
      show: {
        addCard: false,
        previewVisible: false,
      },
      previewImage: '',
      form: {
        addCard: {
          title: '',
          content: '',
          url: '',
          image: '',
          type: 0,
          sort: '',
        },
      },
      fileList: [],
      uploadConf: {
        headers: {
          'crabapples-token': sessionStorage.getItem('token'),
        },
        url: '',
      },
      options: {
        types: [
          {label: '文本', value: 0},
          {label: '图片', value: 1},
        ]
      }
    }
  },
  beforeCreate() {
  },
  activated() {
    this.loadData()
  },
  mounted() {
  },
  methods: {
    editCard(item) {
      this.show.addCard = true
      this.form.addCard = item
      if (item.type === 1) {
        this.fileList = [{
          uid: '-1',
          name: 'image.png',
          status: 'done',
          url: item.image,
        }]
      }

    },
    delCard(id) {
      this.$http.post(`${api.delSettings}/${id}`).then(result => {
        if (result.status === 200) {
          this.$message.success(result.message)
          this.closeAddCard()
          this.resetFrom()
          this.loadData()
        }
      })
    },
    loadData() {
      this.$http.get(api.getSettingsList).then(result => {
        if (result.status === 200) {
          this.dataList = result.data
        }
      })
    },
    async handlePreview(file) {
      if (!file.url && !file.preview) {
        file.preview = await this.getBase64(file.originFileObj);
      }
      this.previewImage = file.url || file.preview;
      this.show.previewVisible = true;
    },
    beforeUpload(file, fileList) {
      this.uploadConf.url = `${SysApis.uploadFile}`
      console.log(this.uploadConf.headers)
      this.fileList = fileList
      return true
    },
    handleCancel() {
      this.show.previewVisible = false;
    },
    showAddCard() {
      this.show.addCard = true
    },
    closeAddCard() {
      this.show.addCard = false
      this.resetFrom()
      this.loadData()
    },
    submitAddCard() {
      this.$http.post(api.saveSettings, this.form.addCard).then(result => {
        if (result.status === 200) {
          this.$message.success(result.message)
          this.closeAddCard()
        }
      })
    },
    resetFrom() {
      this.form.addCard = {
        title: '',
        content: '',
        url: '',
        image: '',
        type: 0,
        sort: ''
      }
    },
    getBase64(file) {
      return new Promise((resolve, reject) => {
        const reader = new FileReader();
        reader.readAsDataURL(file);
        reader.onload = () => resolve(reader.result);
        reader.onerror = error => reject(error);
      });
    },
    uploadFile(info) {
      this.fileList = info.fileList.slice(-1)
      if (info.file.status === 'done') {
        if (info.file.response.status === 200) {
          this.$message.success(`${info.file.name} 上传成功`);
          this.form.addCard.image = info.file.response.data.path
        }
      } else if (info.file.status === 'error') {
        this.$message.error(`${info.file.name} 上传失败`);
      }
    },

  },
};
</script>
<style scoped>
.cards {
  display: inline-block;
  width: 23%;
  margin: 10px;
  overflow: hidden;
  text-overflow: ellipsis;
  white-space: nowrap;
}

</style>
